import config from '@/config'; // eslint-disable-line import/extensions

const RENDER_SERVERS_PATH = '/api/v1/core/servers?render=1';
const REQUEST_TIMEOUT = 5000;

/**
 * Список актуальных серверов рендера из controlpanel.
 *
 * Намеренно на голом fetch, а не на httpClient: у того другой baseURL и
 * интерцептор с алертами и редиректом на /error, а падение controlpanel
 * не должно быть заметно пользователю бэкофиса.
 */
export const fetchRenderServers = async () => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT);

  try {
    const response = await fetch(`${config.apiControlPanel}${RENDER_SERVERS_PATH}`, {
      headers: {
        Accept: 'application/json',
        Authorization: `Token ${config.apiControlPanelToken ?? ''}`,
      },
      signal: controller.signal,
    });

    if (!response.ok) {
      throw new Error(`Control panel responded with status ${response.status}`);
    }

    const servers = await response.json();

    if (!Array.isArray(servers)) {
      throw new Error('Control panel returned an unexpected payload');
    }

    return servers.filter(({ name, label } = {}) => name && label);
  } finally {
    clearTimeout(timeoutId);
  }
};
